import { camelCase, forEach, isArray, isPlainObject } from "lodash";

/**
 * This will return an object where the keys are camelCased
 * @example const myObj = objectKeysToCamelCase(obj)
 * @return Returns a formatted object
 */

export const objectKeysToCamelCase = (snake_case_object) => {
  const camelCaseObject = {};
  const camelCaseArray = [];
  forEach(snake_case_object, function (value, key) {
    if (isPlainObject(value) || isArray(value)) {
      // checks that a value is a plain object or an array - for recursive key conversion
      value = objectKeysToCamelCase(value); // recursively update keys of any values that are also objects
    }
    if (isArray(snake_case_object)) camelCaseArray.push(value);
    else camelCaseObject[camelCase(key)] = value;
  });
  if (isArray(snake_case_object)) return camelCaseArray;
  else return camelCaseObject;
};
